import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@tempmee/react';
import Styles from './ContentPane.module.scss';

/**
 * The Admin Panel v3 page canvas: a subdued grey surface with a 24px gutter
 * that a page's header, filter card, and table sit on.
 *
 * AppShell's `main` carries no padding or tint of its own, so each migrated
 * route opts in by wrapping its content in this. Horizontal and bottom
 * padding only — ListPageHeader already owns the 24px above the title, and
 * doubling it up pushed the header visibly low.
 */
export const ContentPane = ({ children }) => (
  <Box className={`bg-background-subdued ${Styles.pane}`} px={6} pb={6}>
    {children}
  </Box>
);

ContentPane.propTypes = {
  children: PropTypes.node,
};

ContentPane.defaultProps = { children: null };

export default ContentPane;
